module.exports = __webpack_public_path__ + "media/images/flags/4x3/ecu-30a0a3008824b3efc2e2a9875802e938.svg";